import smoothscroll from "smoothscroll-polyfill";

const scrollToPos = ({ top = 0, left = 0, behavior = "smooth" } = {}) => {
  window.scrollTo({
    top,
    left,
    behavior,
  });
};

function initMobileAboutButton() {
  const target = document.querySelector("#js-mobile-section-products");
  const aboutBtn = document.querySelector(".js-about-next-btn");
  aboutBtn &&
    aboutBtn.addEventListener("click", function () {
      const { y } = target.getBoundingClientRect();
      scrollToPos({ top: y });
    });
}

function initReveal() {
  const cdn = "https://cdnjs.cloudflare.com/ajax/libs/reveal.js/4.1.2/";

  const rNextBtn = document.querySelectorAll(".js-reveal-next-btn");
  const rPrevBtn = document.querySelectorAll(".js-reveal-prev-btn");
  const revealMenuBar = document.querySelector(".js-reveal-menubar");
  const revealsMenuLinks = revealMenuBar.querySelectorAll("a");

  Reveal.initialize({
    center: false,
    controls: false,
    mouseWheel: false,
    controlsTutorial: false,
    progress: false,
    history: false,
    loop: true,
    help: false,
    hash: false,
    disableLayout: true,
    display: "flex",
    transition: "slide", // default / none / slide / concave / convex / zoom
    transitionSpeed: "default", // default / fast / slow
    backgroundTransition: "default", // default / none / fade / slide / convex / concave/ zoom
    // parallaxBackgroundImage: revealImagePath,
    // Parallax background size
    parallaxBackgroundSize: "4081px 2304px", //"8192px 4608px",
    parallaxBackgroundHorizontal: null,
    parallaxBackgroundVertical: null,
    dependencies: [
      // Comment in/out as needed
      {
        src: cdn + "lib/js/classList.js", // Cross-browser shim that fully implements classList
        condition: function () {
          return !document.body.classList;
        },
      },
    ],
  });

  function initRevealNavigation() {
    revealsMenuLinks.forEach((link, index) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        setNavigationItemActive(index);
        Reveal.slide(1, index, 0);
      });
    });
  }

  function setNavigationItemActive(activeIndex) {
    revealsMenuLinks.forEach((node) => {
      node.classList.remove("active");
    });
    if (revealsMenuLinks[activeIndex]) {
      revealsMenuLinks[activeIndex].classList.add("active");
    }
  }

  function setNavbarVisibility(ev) {
    const indexh = ev.indexh;
    const indexv = ev.indexv;
    if (indexh === 0 && indexv === 0) {
      revealMenuBar.classList.add("hidden");
    } else {
      revealMenuBar.classList.remove("hidden");
    }
  }

  Reveal.on("ready", function (e) {
    setNavbarVisibility(e);
    initRevealNavigation();
  });

  Reveal.on("slidechanged", function (e) {
    setNavbarVisibility(e);
    setNavigationItemActive(e.indexv);
  });

  rPrevBtn.forEach((element) => {
    if(!element) return;
    element.addEventListener("click", function () {
      const { h, v } = Reveal.getIndices();
      if (h === 1 && v === 0) {
        Reveal.slide(0, 0, undefined);
      } else {
        Reveal.prev();
      }
    });
  });

  rNextBtn.forEach((element) => {
    if(!element) return;
    element.addEventListener("click", function () {
      Reveal.next();
    });
  });

  (function () {
    const images = document.querySelectorAll(
      ".reveal__products .reveal__right-block img"
    );
    const links = document.querySelectorAll(
      ".reveal__products .reveal__links a"
    );

    const handleHover = (e, index) => {
      links.forEach((node) => {
        node.classList.remove("active");
      });
      images.forEach((node) => {
        node.classList.remove("active");
      });
      images[index].classList.add("active");
      e.currentTarget.classList.add("active");
    };

    links.forEach((element, index) => {
      element.addEventListener("mouseover", (e) => handleHover(e, index));
    });
  })();

  function toggleReveal() {
    const ww = $(window).width();
    if (ww < 990) {
      $("body").removeClass("reveal-viewport");
      $("html").removeClass("reveal-full-page");
    } else {
      $("body").addClass("reveal-viewport");
      $("html").removeClass("reveal-full-page");
      Reveal.sync();
    }
  }

  Reveal.on("ready", toggleReveal);

  $(window).on("resize", toggleReveal);
}
if (window.revealImagePath) {
  initMobileAboutButton();
  initReveal();
}

const vid = document.getElementById("home-video");

if (window.matchMedia("(prefers-reduced-motion)").matches) {
  vid.removeAttribute("autoplay");
  vid.pause();
}

function vidFade() {
  vid.classList.add("stopfade");
}

vid && vid.addEventListener("ended", function () {
  // only functional if "loop" is removed
  vid.pause();
  // to capture IE10
  vidFade();
});
